
import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../components/ui/table";

import { DirectorSession } from "../../../types/CustomerInterface";

interface directorSessionProps {
  directors?: DirectorSession[]
}


export const DirectorDetailsSection: React.FC<directorSessionProps> = ({ directors }) => {


  return (
    <section className="mb-6">
      <div className="flex items-center gap-3 mb-6">
        {/* <div className="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center">
          <span className="text-white font-bold text-sm">5</span>
        </div> */}
        <h3 className="text-xl font-bold text-[#9e7926]">Key Management People</h3>
      </div>

      <div className="bg-white rounded-lg border shadow-sm overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-gray-50">
              <TableHead className="font-semibold text-gray-900">Name</TableHead>
              <TableHead className="font-semibold text-gray-900">DIN</TableHead>
              <TableHead className="font-semibold text-gray-900">Designation</TableHead>
              <TableHead className="font-semibold text-gray-900">Tenure</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {directors?.map((director, index) => (
              <TableRow key={index} className="hover:bg-gray-50">
                <TableCell className="font-medium">{director.name}</TableCell>
                <TableCell className="font-mono text-sm">{director.din}</TableCell>
                <TableCell>{director.designation}</TableCell>
                <TableCell>


                  {(director.tenure ? (<span className="bg-purple-100 text-purple-800 text-xs px-2 py-1 rounded-full font-medium">
                    {director.tenure || "-"}
                  </span>) : (<p>-</p>)

                  )}

                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </section>
  );
};
